import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import { GoArrowLeft } from "react-icons/go";
import { FiArrowRight } from "react-icons/fi";
import { useSwipeable } from "react-swipeable";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { MdKeyboardArrowRight } from "react-icons/md";

const layers = [
  {
    id: 1,
    title: "Designing the Best Websites",
    subtitle: "for All Businesses Nationwide",
    description:
      "We design and develop websites that are fast, modern, and built to grow your business. Every site we create focuses on performance, usability, and real results. ",
    services:
      "UI/UX Design | UI/UX Consulting | UX Research | Usability Testing | Design System | Heuristic Evaluation | Interaction Design.",
    buttonText: "See Our Projects",
    image: "/assets/service-img.svg",
  },
  {
    id: 2,
    title: "Creating Powerful Digital Experiences",
    subtitle: "for Growing Businesses",
    description:
      "Our digital marketing strategies help businesses increase visibility, drive quality traffic, and generate real leads. We focus on data-driven campaigns that deliver measurable results.",
    services:
      "Content Marketing | Search Engine Optimization |Social Media Marketing | Analytics & Reporting",
    buttonText: "See Our Projects",
    image: "/assets/digital-marketing.jpg",
  },
  {
    id: 3,
    title: "Mobile App Development",
    subtitle: "Turning  into powerful mobile experiences",
    description:
      "We design and develop powerful mobile applications that deliver seamless user experiences across Android and iOS platforms.  ",
    services:
      "Android App Development | iOS App Development | Cross-Platform App Development | App Maintenance & Support",
    buttonText: "See Our Projects",
    image: "/assets/mobile.jpg",
  },
];

export default function StylishSlider() {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(0);
  const total = layers.length;

  const nextLayer = () => {
    setDirection(1);
    setIndex((prev) => (prev + 1) % layers.length);
  };

  const prevLayer = () => {
    setDirection(-1);
    setIndex((prev) => (prev - 1 + layers.length) % layers.length);
  };

  const nextSlide = () => {
    setDirection(1);
    setIndex((prev) => (prev + 1) % total);
  };

  const prevSlide = () => {
    setDirection(-1);
    setIndex((prev) => (prev - 1 + total) % total);
  };

  useEffect(() => {
    const interval = setInterval(nextSlide, 4000);
    return () => clearInterval(interval);
  }, []);

  const handlers = useSwipeable({
    onSwipedLeft: nextSlide,
    onSwipedRight: prevSlide,
    trackMouse: true,
  });

  return (
    <>
      <div className="hidden md:block relative w-full z-10">
        <button
          onClick={prevLayer}
          className="absolute -left-14 top-1/2 -translate-y-1/2 z-50 bg-white text-primary p-2 rounded-full shadow-lg hover:shadow-xl hover:scale-110 transition-transform duration-300"
        >
          <MdKeyboardArrowLeft size={20} />
        </button>

        <div className="relative w-[270px] md:w-full bg-white    overflow-hidden min-h-[650px] flex items-center justify-center px-4 md:px-16 rounded-3xl">
          <AnimatePresence mode="wait">
            <motion.div
              key={layers[index].id}
              initial={{ x: "100%", opacity: 0 }}
              animate={{ x: "0%", opacity: 1 }}
              exit={{ x: "-100%", opacity: 0 }}
              transition={{ duration: 0.7, ease: "easeInOut" }}
              className="w-full flex flex-col md:flex-row items-center justify-between gap-8 md:gap-16"
            >
              <div className="flex-1 -mt-20 md:mt-0 md:space-y-8">
                <h2 className="font-clash text-gray-800 leading-tight text-[16px] sm:text-[36px] md:text-[48px] lg:text-[50px] drop-shadow-md mt-14 md:mt-0">
                  {layers[index].title}{" "}
                  <span className="text-primary font-semibold">
                    {layers[index].subtitle}
                  </span>
                </h2>

                <p className="font-aileron text-gray-700 text-[12px] sm:text-lg md:text-xl lg:text-[18px] leading-relaxed max-w-[700px] mt-4">
                  {layers[index].description}
                </p>

                {layers[index].services && (
                  <p className="font-aileron text-gray-500 text-[12px] sm:text-base md:text-lg lg:text-[18px] leading-relaxed max-w-[600px] mt-4">
                    {layers[index].services}
                  </p>
                )}

                {layers[index].buttonText && (
                  <button className="bg-primary font-clash font-semibold text-white px-2 py-2 text-xs md:px-6 md:py-3 rounded-lg  md:text-lg mt-28 md:mt-6 shadow-lg hover:shadow-xl transition-transform duration-300 hover:scale-105">
                    {layers[index].buttonText}
                  </button>
                )}
              </div>

              <div className="flex-1 flex justify-center lg:justify-end">
                <img
                  src={layers[index].image}
                  alt=""
                  className="w-full max-w-[300px] sm:max-w-[360px] md:max-w-[440px] lg:max-w-[520px] h-auto object-contain transition-transform duration-300 hover:scale-105 drop-shadow-2xl"
                />
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

        <button
          onClick={nextLayer}
          className="absolute -right-14 top-1/2 -translate-y-1/2 z-50 bg-white text-primary p-2 rounded-full shadow-lg hover:shadow-xl hover:scale-110 transition-transform duration-300"
        >
          <MdKeyboardArrowRight size={20} />
        </button>
      </div>

      <div className="md:hidden relative w-full bg-white px-2 rounded-3xl" {...handlers}>
        {/* CARD */}
        <div className="relative w-full overflow-hidden min-h-[620px] flex items-center justify-center ">
          <AnimatePresence custom={direction} mode="wait">
            <motion.div
              key={layers[index].id}
              className="w-full flex flex-col items-center gap-6"
              custom={direction}
              initial={(dir) => ({ x: dir === 1 ? 200 : -200, opacity: 0 })}
              animate={{ x: 0, opacity: 1 }}
              exit={(dir) => ({ x: dir === 1 ? -200 : 200, opacity: 0 })}
              transition={{ duration: 0.45, ease: "easeInOut" }}
            >
              {/* IMAGE */}
              <div className="w-full flex justify-center mt-4">
                <div className="bg-gray-50 rounded-2xl shadow-md">
                  <img
                    src={layers[index].image}
                    alt=""
                    className="w-full max-w-[260px] object-contain"
                  />
                </div>
              </div>

              {/* TEXT */}
              <div className="w-full text-center space-y-4">
                <h2 className="text-[22px] font-semibold text-gray-800 leading-snug">
                  {layers[index].title}{" "}
                  <span className="text-primary">{layers[index].subtitle}</span>
                </h2>

                <p className="text-gray-600 text-sm leading-relaxed px-3">
                  {layers[index].description}
                </p>

                <p className="text-gray-500 text-sm px-3">
                  {layers[index].services}
                </p>

                <div className="pt-2">
                  <button className="bg-primary text-white px-6 py-2 rounded-xl text-sm font-semibold shadow-md active:scale-95 transition">
                    {layers[index].buttonText}
                  </button>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

        {/* BULLETS */}
        <div className="flex justify-center gap-2 mt-3 mb-3">
          {layers.map((_, i) => (
            <button
              key={i}
              onClick={() => {
                setDirection(i > index ? 1 : -1);
                setIndex(i);
              }}
              className={`h-2 rounded-full transition-all duration-300 
          ${i === index ? "w-6 bg-primary" : "w-2 bg-gray-300"}
        `}
            />
          ))}
        </div>
      </div>
    </>
  );
}
